import { callExternalApi } from '../callExternalApi';

export interface ThoughtSpotTokenResponse {
  username: string;
  token: string;
}

export const getThoughtspotToken = async () => {
  return callExternalApi<ThoughtSpotTokenResponse | null>({
    url: `${process.env.REACT_APP_API_SERVER_URL}/api/user/thoughtspot_token`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
